import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConsultasService } from '@app/services/consultas.service';
import { NotaFiscalService } from '@app/services/nota-fiscal.service';

import { IdDescricao } from '@app/models/util/id-descricao';
import { NotaFiscal } from '@app/models/nota-fiscal.model';
import { ClasseImposto } from '@app/models/classe-imposto.model';

import debounce from '@app/utils/debounce';
import { ReceberService } from '@app/services/receber.service';

@Component({
  selector: 'app-nota-fiscal-form',
  templateUrl: './nota-fiscal-form.component.html'
})
export class NotaFiscalFormComponent implements OnInit {

  lstParticipante = [];
  _debounce: any;
  _pesquisa: any;

  processoId: number;

  lstClasseImposto: ClasseImposto[] = [];
  lstErros: string[] = [];
  nota: NotaFiscal = new NotaFiscal();

  aguardando: boolean = false;
  issRetido: boolean = false;
  tomadorResponsavelRetencao: boolean = false;
  receberProcessoVinculado: boolean = false;

  constructor(
    private consultasService: ConsultasService,
    private notaFiscalService: NotaFiscalService,
    private receberService: ReceberService,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(ToastrService) private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      this.processoId = params['processoId'];
      this.nota.ReceberId = params['id'];

      if(this.nota.ReceberId && this.processoId){
        this.buscarReceberProcesso();
      }
    });

    this.notaFiscalService.buscarClasseImposto().subscribe((data) => {
      this.lstClasseImposto = data;
      this.lstClasseImposto.forEach(classe => {
        classe.descricaoHTML = classe.referencia + " - " + classe.descricao;
      });
    })
  }

  buscarReceberProcesso(){
    this.receberService.obterPorId(this.nota.ReceberId).subscribe((data) => {
      this.lstParticipante = [{ Id: data.ParticipanteId, Descricao: data.Participante.NomeFantasia }];
      this.nota.ParticipanteTomadorId = data.ParticipanteId;
      this.nota.Valor = data.ValorRecebido;
      this.receberProcessoVinculado = true;
    });
  }

  gerarNovaNota(){
    this.aguardando = true;

    if(!this.validaCamposObrigatorios()){
      this.aguardando = false;
      return;
    }
    
    this.notaFiscalService.gravar(this.nota).subscribe(
      () => {
        this.toastr.success("NFSe gerada com sucesso!");
        if(this.receberProcessoVinculado){
          this.aguardando =  false;
          this.router.navigate(['/processos/processo', this.processoId,'financeiro']);
        } 
        else
        {
          this.aguardando =  false;
          this.router.navigate(['/financeiro/nota-fiscal']);
        }
      },
      (erro) => {
        this.aguardando = false;
        this.lstErros = erro.error.errors;
      }
    );
  }

  validaCamposObrigatorios(){
    if(!this.nota.Discriminacao){
      this.toastr.error("Campo Discriminação é obrigatório!");
      return false;
    }

    if(!this.nota.Valor){
      this.toastr.error("Campo Valor é obrigatório!");
      return false;
    }

    if(!this.nota.ReferenciaClasseImposto){
      this.toastr.error("Campo Classe de Imposto é obrigatório!");
      return false;
    }

    if(!this.nota.ParticipanteTomadorId){
      this.toastr.error("Obrigatório informar participante!");
      return false;
    }

    return true;
  }

}
